import * as Sentry from "@sentry/react";

const dsn = import.meta.env.VITE_SENTRY_DSN;
const mode = import.meta.env.MODE;

// Debug logging
console.log("🔍 Sentry Debug Info:", {
  hasDSN: !!dsn,
  dsnPreview: dsn ? dsn.substring(0, 30) + "..." : "MISSING",
  mode: mode,
  allEnvVars: Object.keys(import.meta.env).filter(k => k.startsWith('VITE_'))
});

if (!dsn) {
  console.error("❌ Sentry DSN not found! Make sure VITE_SENTRY_DSN is set in .env.local");
} else {
  console.log("✅ Sentry DSN found, initializing...");
}

Sentry.init({
  dsn: dsn,
  environment: mode,
  debug: mode === 'development', // Enable Sentry's internal debug logs
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: true,
      blockAllMedia: true,
    }),
  ],
  // Performance Monitoring
  tracesSampleRate: mode === 'production' ? 0.1 : 1.0, // 10% in prod, 100% in dev
  // Session Replay
  replaysSessionSampleRate: mode === 'production' ? 0.1 : 1.0,
  replaysOnErrorSampleRate: 1.0, // Always record when error occurs
  
  // Set user context when authenticated
  beforeSend(event, hint) {
    console.log("📤 Sentry beforeSend:", event.exception?.values?.[0]?.value || "No exception");
    // Filter out known non-critical errors
    if (event.exception) {
      const error = hint.originalException;
      // Ignore network errors that are expected
      if (error instanceof TypeError && error.message.includes('Failed to fetch')) {
        console.log("🚫 Filtered out network error");
        return null;
      }
      // Ignore CORS errors (expected in some cases)
      if (error instanceof TypeError && error.message.includes('CORS')) {
        console.log("🚫 Filtered out CORS error");
        return null;
      }
    }
    return event;
  },
});

console.log("✅ Sentry initialization complete");
